import * as types from '../actions/medication/types';


const INITIAL_STATE = [];

export default function medicationReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.GET_MEDS:
      return action.payload;

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/medicationReducer.js